<span class="new-badge"> {{'HEADER.ALL_PAGES.HEADER.SUGGESTIONS.SEARCH_BY_PHOTO.NEW_BADGE' | translate}} </span>
